import { identity, user, organization } from "orion-components/Session/Reducers";
import { default as dock } from "orion-components/Dock/Reducers";
import { notifications, userFeeds, alerts } from "orion-components/GlobalData/Reducers";
import { global, dialog } from "orion-components/AppState/Reducers";
import { default as contextualData } from "orion-components/ContextualData/Reducers";
import serviceReducers from "orion-components/Services";
// serviceReducers includes all services from orion-components
// This filters out reducers not needed (baseMaps, systemHealth, etc.) for this app and disables their initializing action
const {
	baseMaps,
	systemHealth,
	systemNotifications,
	application,
	statusCards,
	eventLookups,
	...filteredServiceReducers
} = serviceReducers;
import { combineReducers } from "redux";

import optimist from "redux-optimist";

const rootReducer = optimist(
	combineReducers({
		session: combineReducers({ identity, user, userFeeds, organization }),
		appState: combineReducers({ dock, global, dialog }),
		globalData: combineReducers({ notifications, alerts }),
		contextualData,
		...filteredServiceReducers
	})
);

export default rootReducer;
